import { Currency, CryptoCurrency, FiatCurrency } from './types';

const cryptos: Record<CryptoCurrency, true> = {
  ADA: true,
  USDC: true,
  ALGO: true,
  BCH: true,
  BTC: true,
  DOGE: true,
  DOT: true,
  ETH: true,
  LINK: true,
  LTC: true,
  SOL: true,
  USDT: true,
  XLM: true,
  XRP: true,
  EURQ: true,
};

export const isCrypto = (c: Currency): c is CryptoCurrency => {
  return c in cryptos;
};

export const isFiat = (c: Currency): c is FiatCurrency => {
  return !(c in cryptos);
};

export const scales: Record<Currency, number> = {
  BTC: 8,
  BCH: 8,
  LTC: 8,
  ETH: 18,
  ADA: 6,
  DOT: 10,
  LINK: 18,
  USDT: 6,
  USDC: 6,
  SEK: 2,
  USD: 2,
  EUR: 2,
  NOK: 2,
  ALGO: 6,
  DOGE: 8,
  XLM: 7,
  SOL: 9,
  XRP: 6,
  EURQ: 8,
};
